import moment from 'moment'

// The request-body keys of a report's quick filters, built one way for the main table (Reports.vue) and the
// grouped view (ReportsGroupTable.vue). The grouped view had its own copy that read an array selection as if it
// were one item (multi-select dropdowns were dropped) and used moment without importing it (dates were dropped).
//
// fields:    dbViewFieldsForQuickFilters
// selection: quickFiltersSelection (per field: an array of items, one item, a string, or a date modifier)
// Adds the keys to quickFilters and returns it.
export function addQuickFilters(quickFilters, { fields, selection, datesFrom, datesTo }) {
  for (let i = 0; i < fields.length; i++) {
    try {
      const field = fields[i]
      if (!field.filterDropdown) continue
      const a = field.colField.split('.').slice(0)[0]
      const b = field.colField.split('.').slice(-1)[0]
      const picked = selection[i]

      if (picked) {
        if (field.colType === 'Date') {
          if (picked.dateModifierFunc === 'custom') {
            if (datesFrom[i]) {
              try {
                quickFilters[`${a}From`] = moment(datesFrom[i], 'DD/MM/YYYY').format('YYYY/MM/DD')
              } catch (e) {
                quickFilters[`${a}From`] = datesFrom[i]
              }
            }
            if (datesTo[i]) {
              try {
                quickFilters[`${a}To`] = moment(datesTo[i], 'DD/MM/YYYY').format('YYYY/MM/DD')
              } catch (e) {
                quickFilters[`${a}To`] = datesTo[i]
              }
            }
          } else {
            quickFilters[a] = picked.dateModifierFunc
          }
        } else if (picked[b] === 'Yes') {
          quickFilters[a] = true
        } else if (picked[b] === 'No') {
          quickFilters[a] = false
        } else if (field.lovEP && field.lovEP.substr(0, 1) === '*') {
          quickFilters[a] = picked[b]
        } else if (typeof picked === 'string') {
          quickFilters[a] = picked
        } else if (picked.length > 0) {
          const key = field.filterFldId || field.colField
          quickFilters[a] = picked.map(item => item[key]).join(',')
        }
      } else if (datesFrom[i] || datesTo[i]) {
        if (field.colType === 'Currency' || field.colType === 'Number') {
          quickFilters[`${a}From`] = datesFrom[i]
          quickFilters[`${a}To`] = datesTo[i]
        }
      }
    } catch (e) {
      continue
    }
  }
  return quickFilters
}
